import { render, staticRenderFns } from "./paymentOkPage.vue?vue&type=template&id=e7d14a3a&scoped=true&"
import script from "./paymentOkPage.vue?vue&type=script&lang=ts&"
export * from "./paymentOkPage.vue?vue&type=script&lang=ts&"
import style0 from "./paymentOkPage.vue?vue&type=style&index=0&id=e7d14a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d14a3a",
  null
  
)

export default component.exports